import Site from './classes/Site';

declare global {
  interface Window {
    spotifyController: SpotifyEmbedController;
  }
}

interface SpotifyEmbedController {
  loadUri: (uri: string) => void;
  play: () => void;
}

interface SpotifyIframeApi {
  createController: (
    element: HTMLElement | null,
    options: { uri: string },
    callback: (EmbedController: SpotifyEmbedController) => void
  ) => void;
}

window.onSpotifyIframeApiReady = (IFrameAPI: SpotifyIframeApi) => {
        
    const options = {
        uri: 'spotify:album:6mSOFYdXgHArMclsPZTA40',
    };

    const element = document.getElementById('embed-iframe');
    
    const callback = (EmbedController: SpotifyEmbedController) => {

        window.spotifyController = EmbedController;

        document.querySelectorAll('.track-image').forEach(
            (episode: Element) => {
                episode.addEventListener('click', () => {
                    const spotifyId = (episode as HTMLElement).dataset.spotifyId;
                    if (spotifyId) {
                        EmbedController.loadUri(spotifyId);
                        EmbedController.play();
                    }
                });
            }
        );
    };

    IFrameAPI.createController(element, options, callback);
}

new Site();
